import { ScrollView } from 'react-native';
import { useLocalSearchParams, Redirect } from 'expo-router';
import { Box } from '@/components/ui/primitives';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { useLeagueContext } from '@/contexts/LeagueContext';
import AdminPicksManagement from '@/components/AdminPicksManagement';
import MarchMadnessLeagueView from '@/components/MarchMadnessLeagueView';
import { getLandingHref } from '@/lib/routes';
import { leagueRouteStyles } from '@/components/route/leagueRouteStyles';

export default function LeagueAdminRoute() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const context = useLeagueContext();

  if (!id || id === 'undefined') {
    return <Redirect href={getLandingHref()} />;
  }

  const {
    resolvedSeasonId,
    league,
    activeWeek,
  } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        {context.isMarchMadness ? (
          <Box flex={1}>
            <MarchMadnessLeagueView
              leagueId={id}
              seasonId={resolvedSeasonId || ''}
              section="admin"
              currentUserId={context.league?.currentUserId}
              permissions={context.permissions}
            />
          </Box>
        ) : (
          <ScrollView style={leagueRouteStyles.flex} contentContainerStyle={leagueRouteStyles.content}>
            <AdminPicksManagement
              leagueId={id}
              selectedWeekId={activeWeek?.id || ''}
              seasonId={resolvedSeasonId ?? undefined}
            />
          </ScrollView>
        )}
      </Box>
    </NativeTabFocusGate>
  );
}
